import React from "react";
import './DistrictTargetTable.scss';


const DistrictTargetTable = ({ data, title }) => {
    const sortedData = [...data].sort((a, b) =>
        a.district_name.localeCompare(b.district_name, undefined, { sensitivity: 'base' })
    );
    return (
        <div className="table_new_container">
            <table className="targets_new_table">
                <thead>
                    <tr>
                        <th colSpan={5} style={{ textAlign: 'center' }}>{title}</th>
                    </tr>
                    <tr>
                        <th>Cost Center</th>
                        <th>Target</th>
                        <th>Achieved</th>
                        <th>Pending</th>
                        <th>Percentage</th>

                    </tr>
                </thead>
                <tbody>
                    {sortedData.length === 0 ? (
                        <tr>
                            <td colSpan={5} style={{ textAlign: 'center', color: '#888', fontStyle: 'italic' }}>
                                No target found
                            </td>
                        </tr>
                    ) : (
                        sortedData.map((row, idx) => {
                            const target = Number(row.target_price) || 0;
                            const achieved = Number(row.achieved) || 0;
                            const pending = Number(row.pending) || 0;
                            const percent = target > 0 ? ((achieved / target) * 100).toFixed(2) : "0.00";
                            return (
                                <tr key={row.district_id || idx}>
                                    <td>{row.district_name}</td>
                                    <td style={{ textAlign: 'right' }}>{target.toFixed(0)}</td>
                                    <td style={{ textAlign: 'right' }}>{achieved.toFixed(0)}</td>
                                    <td style={{ textAlign: 'right' }}>{pending.toFixed(0)}</td>
                                    <td style={{ textAlign: 'right' }}>{percent}%</td>
                                </tr>
                            );
                        }))}
                </tbody>
            </table>
        </div>
    );
};

export default DistrictTargetTable;